import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { SectionCollapse } from 'shared/ui'
import { useChatbotContext } from 'pages/chatbot/context'

import { ChatbotActions } from '../ChatbotActions'

export const StepSuccessActions = observer(() => {
  const { errors, successActions } = useChatbotContext()

  const error = errors.getError('success_actions')
  const isOwnError = errors.hasOwnError('success_actions')
  const isNestedError = errors.hasError('success_actions')

  const successActionsError = isOwnError
    ? error
    : isNestedError
    ? 'Please complete all the fields'
    : null

  useEffect(() => {
    if (!!successActions.list.length && isOwnError) errors.removeError('success_actions')
  }, [successActions.list, isOwnError])

  return (
    <SectionCollapse
      icon='successCircle'
      title='Success actions'
      tooltipProps={{
        label:
          'These actions will happen once your AI Agent has collected all the fields you set in your objective',
        placement: 'top',
        breakWord: true,
        maxWidth: 360,
      }}
      error={successActionsError}
    >
      <ChatbotActions actions={successActions} emptyPlaceholder='Please add actions' />
    </SectionCollapse>
  )
})
